module.exports = __webpack_public_path__ + "img/file-icon.7cbf4ae9.svg";